import React from 'react';

const OFFER_TYPES = [
  { value: 'kupovina', label: 'Tražim', color: 'blue' },
  { value: 'prodaja', label: 'Nudim', color: 'green' },
];

const colorMap = {
  blue: 'border-blue-500 bg-blue-50 text-blue-700',
  green: 'border-green-500 bg-green-50 text-green-700',
};

export default function OfferTypeSelector({ value, onChange, error }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Tip oglasa <span className="text-red-500">*</span>
      </label>
      <div className="grid grid-cols-2 gap-3">
        {OFFER_TYPES?.map((type) => (
          <button
            key={type?.value}
            type="button"
            onClick={() => onChange(type?.value)}
            className={`p-3 border-2 rounded-lg text-center transition-all ${
              value === type?.value
                ? colorMap?.[type?.color]
                : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300'
            }`}
          >
            <div className="font-semibold text-sm">{type?.label}</div>
          </button>
        ))}
      </div>
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
}
